import axios from '../../http'
import { handleGetRequestParams } from '../../common/js/util'

class xbRepair {
  // 获取前台返修单列表
  getXBRepairList(options) {
    let url = '/api/xb/repair/list?'
    url += handleGetRequestParams(options)
    console.log(url);
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
}

export default xbRepair